import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
} from "react-bootstrap";
import Sidebar from "../../Components/base/sidebar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BsEye, BsPencilSquare, BsTrash, BsTrashFill } from "react-icons/bs";
import CreateNew from "../../Components/Button/CreateNew";
import CurrentDraftsTable from "../../Components/Tables/CurrentDraftsTable";
import CurrentLatestTable from "../../Components/Tables/CurrentLatestTable";
import CurrentApprovalsTable from "../../Components/Tables/CurrentApprovalsTable";

interface Item {
  id: number;
  category: string;
  sub_category: string;
  title: string;
  author: string;
  status: string;
  // Add more properties as per your item structure
}

export default function Video() {
  const [items, setItems] = useState<Item[]>([]);
  const navigate = useNavigate();
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://stagingbackend.pulp.ph/api/v1/pulpliveworld/video",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        if (isMounted.current) {
          setItems(response.data.videos.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleEditShortstory = (id: number) => {
    navigate("/update/video", { state: { id } }); // Navigate to the VideoEditor without ID in the URL but pass the id through state
  };

  const handleViewShortstory = (id: number) => {
    window.open(`https://stagingbackend.pulp.ph/article/video/${id}`, "_blank");
  };

  const handleDelete = async (id: number) => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        // Handle the case where authToken is not available
        alert("Authentication token not found!");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this content?"
      );
      if (!confirmDelete) {
        return; // If user cancels, do nothing
      }

      await axios.delete(
        `http://127.0.0.1:8000/api/v1/pulpliveworld/video/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      alert("Content Deleted Successfully !!"); // Handle success (e.g., show a success message or redirect)
      window.location.reload();
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      // Handle error (e.g., show an error message)
    }
  };
  const handleApprove = async (id: number) => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        // Handle the case where authToken is not available
        alert("Authentication token not found!");
        return;
      }

      const confirmApprove = window.confirm(
        "Are you sure you want to approve this content?"
      );
      if (!confirmApprove) {
        return; // If user cancels, do nothing
      }

      await axios.post(
        `http://127.0.0.1:8000/api/v1/pulpliveworld/video/${id}`,
        {
          status: "Approved", // Add the status Approved in the request body
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      alert("Content Approved Successfully !!"); // Handle success (e.g., show a success message or redirect)
      window.location.reload();
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      // Handle error (e.g., show an error message)
    }
  };

  const handleDecline = async (id: number) => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        // Handle the case where authToken is not available
        alert("Authentication token not found!");
        return;
      }

      const confirmApprove = window.confirm(
        "Are you sure you want to Decline this content?"
      );
      if (!confirmApprove) {
        return; // If user cancels, do nothing
      }

      await axios.post(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/video/${id}`,
        {
          status: "Declined", // Add the status Approved in the request body
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      alert("Content Declined !!"); // Handle success (e.g., show a success message or redirect)
      window.location.reload();
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      // Handle error (e.g., show an error message)
    }
  };

  return (
    <>
      <div className="w-full">
        <div className="Dashboard-container flex place-content-between">
          <h2 className="mt-5 font-semibold">List of All Video Post</h2>
          <CreateNew />
        </div>

        <div className="container mt-5">
          <h3 className="font-semibold mb-1">Pending Video Post</h3>
          <CurrentDraftsTable
            items={items}
            onView={handleViewShortstory}
            onEdit={handleEditShortstory}
            onDelete={handleDelete}
          />
        </div>

        <CurrentApprovalsTable
          items={items}
          onView={handleViewShortstory}
          onApprove={handleApprove}
          onDecline={handleDecline}
        />

        <div className="container mt-5">
          <h3 className="font-semibold mb-1">All Published Videos</h3>
          <CurrentLatestTable
            items={items}
            onView={handleViewShortstory}
            onEdit={handleEditShortstory}
            onDelete={handleDelete}
          />
        </div>
      </div>
    </>
  );
}
